import { getApiClient } from '../../utils'
import { UploadImageRequest, UploadImageResponse } from './upload-image.types'

export const uploadImageApi = {
  uploadImage: (
    locale: string,
    requestBody: UploadImageRequest,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    config?: { onUploadProgress?: (progressEvent) => void }
  ) =>
    getApiClient(locale)
      .post<{ data: UploadImageResponse }>(
        'v1/files/image',
        requestBody,

        config || {}
      )
      .then(({ data }) => data.data),

  uploadImages: (
    locale: string,
    requestBody: UploadImageRequest,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    config?: { onUploadProgress?: (progressEvent) => void }
  ) =>
    getApiClient(locale)
      .post<{ data: UploadImageResponse[] }>(
        'v1/files/images',
        requestBody,
        config || {}
      )
      .then(({ data }) => data.data)
}

export const uploadFilesApi = {
  uploadFiles: (
    locale: string,
    requestBody: UploadImageRequest,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    config?: { onUploadProgress?: (progressEvent) => void }
  ) =>
    getApiClient(locale)
      .post<{ data: UploadImageResponse[] }>(
        '/v1/files/models',
        requestBody,
        config || {}
      )
      .then(({ data }) => data.data)
}
